import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "./components/Login"
import CampaignList from "./components/CampaignList"
import CurrentCampaign from "./components/CurrentCampaign"
import DirectScoringList from "./components/DirectScoringList"

import { Auth } from './auth';

Vue.use(VueRouter);

const authMiddleware = function ({ next, router }) {
    if (! Auth.isAuthenticated()) {
        return router.replace({ name: `login` });
    }

    return next();
};

const routes = [
    {
        path: '/',
        name: 'home',
        redirect: () => { return '/my-direct-scoring' }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            title: ' <span class="font-weight-light">se</span> connecter',
        }
    },
    {
        path: '/my-current-campaign',
        name: 'campaigns.current',
        component: CurrentCampaign,
        meta: {
            title: ' <span class="font-weight-light">ma</span> campagne',
            middleware: [authMiddleware]
        }
    },
    {
        path: '/my-campaigns',
        name: 'campaigns.index',
        component: CampaignList,
        meta: {
            title: ' <span class="font-weight-light">Mes</span> campagnes',
            middleware: [authMiddleware]
        }
    },
    {
        path: '/my-direct-scoring',
        name: 'direct-scoring.index',
        component: DirectScoringList,
        meta: {
            title: 'Pointage <span class="font-weight-light">direct</span>',
            middleware: [authMiddleware]
        }
    }
];

const router = new VueRouter({
    routes
});

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    // If no subsequent Middleware exists,
    // the default `next()` callback is returned.
    if (!subsequentMiddleware) return context.next;

    return (...parameters) => {
        // Run the default Vue Router `next()` callback first.
        context.next(...parameters);
        // Than run the subsequent Middleware with a new
        // `nextMiddleware()` callback.
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({ ...context, next: nextMiddleware });
    };
}

router.beforeEach((to, from, next) => {
    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware)
            ? to.meta.middleware
            : [to.meta.middleware];

        const context = {
            from,
            next,
            router,
            to,
        };
        const nextMiddleware = nextFactory(context, middleware, 1);

        return middleware[0]({ ...context, next: nextMiddleware });
    }

    return next();
});

export default router;
